import { render, staticRenderFns } from "./MartchipCard.vue?vue&type=template&id=54beef0a"
import script from "./MartchipCard.vue?vue&type=script&lang=js"
export * from "./MartchipCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports